<template>
  <div>
    <b-modal
      id="modalInfoPrueba"
      v-model="isOpen"
      modal-class="modalInfo"
      :title="$t('label_evaluation_requirementEvaluation_evaluationComments')"
      @close="closeModal()"
    >
      <b-container style="text-align: left">
        <b-form-group
          id="comment"
          :label="
            $t(
              'label_evaluation_requirementEvaluation_evaluationComments_description'
            )
          "
          label-for="comment"
        >
          <b-input-group>
            <b-textarea id="comment" v-model="comment.comment" />
          </b-input-group>
        </b-form-group>
        <b-row>
          <b-col>
            <span class="label">
              {{ $t("label_evaluation_requirementEvaluation_post_category") }}
            </span>
          </b-col>
          <b-col>
            <b-form-group>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_general"
              >
                {{ $t("label_evaluation_requirementEvaluation_post_general") }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_commitment"
              >
                {{
                  $t("label_evaluation_requirementEvaluation_post_commitment")
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_documentation"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_documentation"
                  )
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_establishment"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_establishment"
                  )
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_execution"
              >
                {{
                  $t("label_evaluation_requirementEvaluation_post_execution")
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.category"
                name="category"
                value="label_evaluation_requirementEvaluation_post_specialObservations"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_specialObservations"
                  )
                }}
              </b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span class="label">
              {{ $t("label_evaluation_requirementEvaluation_post_scope") }}
            </span>
          </b-col>
          <b-col>
            <b-form-group>
              <b-form-radio
                v-model="comment.scope"
                name="scope"
                value="label_evaluation_requirementEvaluation_post_privateComment"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_privateComment"
                  )
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.scope"
                name="scope"
                value="label_evaluation_requirementEvaluation_post_includeInFinalReport"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_includeInFinalReport"
                  )
                }}
              </b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span class="label">
              {{ $t("label_evaluation_requirementEvaluation_post_visibility") }}
            </span>
          </b-col>
          <b-col>
            <b-form-group>
              <b-form-radio
                v-model="comment.visibility"
                name="visibility"
                value="label_evaluation_requirementEvaluation_post_onlyVisibleToEvaluationTeam"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_onlyVisibleToEvaluationTeam"
                  )
                }}
              </b-form-radio>
              <b-form-radio
                v-model="comment.visibility"
                name="visibility"
                value="label_evaluation_requirementEvaluation_post_visibleToOrganization"
              >
                {{
                  $t(
                    "label_evaluation_requirementEvaluation_post_visibleToOrganization"
                  )
                }}
              </b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span class="label">
              {{ $t("label_evaluation_requirementEvaluation_post_tag") }}
            </span>
          </b-col>
          <b-col>
            <b-form-checkbox v-model="comment.opportunity" name="opportunity">
              {{
                $t(
                  "label_evaluation_requirementEvaluation_post_tag_opportunityArea"
                )
              }}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-button
          variant="primary"
          :disabled="!comment.comment"
          @click="postComment()"
        >
          {{ $t("label_evaluation_requirementEvaluation_post_button") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "TemplateEvaluationCommentsModal",
  props: ["showModalComment", "comment", "requirement"],

  computed: {
    isOpen: function () {
      return this.showModalComment;
    },
  },
  methods: {
    saveAndForce() {
      this.$emit("saveAndForce");
    },
    postComment() {
      if (typeof this.requirement.comments === "undefined") {
        this.requirement.comments = [];
      }
      this.comment.account = this.account;
      this.comment.date = new Date().toLocaleDateString("en-US");
      if (this.comment.indexComment === -1) {
        this.requirement.comments.push(this.comment);
      } else {
        this.requirement.comments[this.indexComment] = this.comment;
        this.requirement.comments[this.indexComment].editedAccount =
          this.account;
        this.requirement.comments[this.indexComment].editedDate =
          new Date().toLocaleDateString("en-US");
        this.indexComment = -1;
      }
      this.saveAndForce();
      this.$emit("closeModal");
    },
    editComment(index) {
      this.requirement.comments[index].editedAccount = this.account;
      this.requirement.comments[index].editedDate =
        new Date().toLocaleDateString("en-US");
      this.requirement.comments[index].edit = false;
      this.saveAndForce();
      this.$forceUpdate();
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style lang="sass" >
/* components/template/_template-evaluation-comments-modal */
</style>